import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';
import { IEICFTemplate, IEICFTemplateInput } from '../EICFTemplate.ts';

export function usePostEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<IEICFTemplate, AppMedError, IEICFTemplateInput>({
        mutationKey: [QueryKeys.eicfTemplates, 'create'],
        mutationFn: (input) => EICFTemplatesApi.post(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfTemplates] });
        },
    });
}
